import { render, staticRenderFns } from "./LottoResult.vue?vue&type=template&id=44047dd3&"
import script from "./LottoResult.vue?vue&type=script&lang=js&"
export * from "./LottoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports